import TheGrid from '@/views/registrations/grid'
import Edit from '@/views/registrations/edit'
import TheView from '@/views/registrations/view'

export default {
  path: '/registrations',
  redirect: '/registrations/index',
  name: 'registrations',
  meta: {
    auth: {
      redirect: {
        name: 'registrations.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Inscrições'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'registrations.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'registrations.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'registrations.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'registrations.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
